module.exports = __webpack_public_path__ + "quicksilver/static/media/bag-20kg.00696414.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/BaggageSelect/img/bag-20kg.svg
// module id = 602
// module chunks = 0